import { selectTeamById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { modelIconNameMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuDynamicIconWithWrapper, type LuDynamicIconWithWrapperProps } from "./LuDynamicIconWithWrapper"
import type { IconsProps, IconType } from "./typings"

interface TeamIconProps extends Omit<LuDynamicIconWithWrapperProps, "color" | "icon" | "fallback"> {
	teamId: string
}

export const TeamIcon = memo<TeamIconProps>((props) => {
	const { ref, teamId, background = true, ...rest } = props

	const team = useAppSelector(selectTeamById(teamId))

	return (
		<LuDynamicIconWithWrapper
			ref={ref}
			color={team?.color}
			icon={(team?.icon ?? modelIconNameMapping.team) as IconType}
			background={background}
			{...rest}
		/>
	)
})
TeamIcon.displayName = "TeamIcon"

interface TeamIconsProps extends IconsProps {
	teamIds: string[]
}

export const TeamIcons = memo<TeamIconsProps>((props) => {
	const { ref, className, teamIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{teamIds.slice(0, max ?? teamIds.length).map((teamId) => (
				<TeamIcon teamId={teamId} key={teamId} />
			))}
		</span>
	)
})
TeamIcons.displayName = "TeamIcons"
